<script>
import { mapActions, mapState } from 'vuex';
import ReviewAvailableDomainsSettingsTable from '../components/review/ReviewAvailableDomainsSettingsTable';
import ReviewAvailableDomainsSettingsDialog from '../components/review/ReviewAvailableDomainsSettingsDialog';

export default {
  name: 'ReviewAvailableDomainsSettings',
  components: {
    ReviewAvailableDomainsSettingsTable,
    ReviewAvailableDomainsSettingsDialog,
  },
  computed: {
    ...mapState({
      brands: state => state.reviewSettings.availableDomains.items,
      fetchPending: state => state.reviewSettings.availableDomains.loading,
      deletingAvailableDomain: state => state.reviewSettings.availableDomains.delete.deleting,
    }),
  },
  data() {
    return {
      tab: 0,
    };
  },
  methods: {
    ...mapActions({
      fetchBrandsAndAvailableDomains: 'reviewSettings/fetchBrandsAndAvailableDomains',
      deleteAvailableDomain: 'reviewSettings/deleteAvailableDomain',
    }),
  },
  created() {
    this.fetchBrandsAndAvailableDomains();
  },
};
</script>

<template>
  <v-card class="ma-3 elevation-3">
    <v-toolbar color="info" dark tabs>
      <v-toolbar-title>{{ $t('reviewSettings.title.text') }}</v-toolbar-title>
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ml-1">info</v-icon>
        </template>
        <span>{{ $t('reviewSettings.title.tooltip') }}</span>
      </v-tooltip>
      <v-spacer/>
      <review-available-domains-settings-dialog
        v-if="!fetchPending"
        v-on:save="fetchBrandsAndAvailableDomains"
        :active-tab="tab"
      />
      <template v-slot:extension>
        <v-tabs v-model="tab" color="info" grow>
          <v-tabs-slider color="error"/>
          <v-tab v-for="brand in brands" :key="brand.id">
            <p>{{ brand.name }}</p>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-progress-linear
      v-if="fetchPending"
      :indeterminate=true
      class="mx-5"
    />
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="brand in brands" :key="brand.id">
        <v-card flat>
          <v-card-text>
            <review-available-domains-settings-table
              v-on:delete="deleteAvailableDomain($event)"
              :available-domains="brand.domains"
              :loading="deletingAvailableDomain"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/pages/ReviewAvailableDomainsSettings.vue